export class Addeditclient {
    clientName!: string;
    contactName!: string;
    email!: string;
    contactNo!: string;
    clientExpiryDate!: string;
    status!: string;
    colorCode!: string;
    monitoringFrequency!: string;
    utilizationReportFrequency!: string;
    intuitCustomerId!: string;
    inTier!: Number;
    inProfilePaymentId!: Number;
    stAddress: any;
    isReviewRequired!: Boolean;
    isRequiredInvoice!: Boolean;
    flgIsAllowLowConfidenceScore!: Boolean;
    flgIsAllowAdditionalIdentity!: Boolean;
    stFaxNumber!: string;
    flgIsIncludeAuth!: Boolean;
    flgIsInsuranceType!: Number;
    inReportType!: Number;
    flgIsPermitVM!: Boolean;
    stLogo: string = '';
    flgIsClientLogo!: Boolean;
    inPriority!:Number;
    inTurnaroundTime!:Number;
    inDeliverable!:Number;
    isVisibleWebPage!: Boolean;
    Addeditclient!:boolean;
    flgIsWhiteLabel!: boolean;
    stReportTypes!: string;
    flgIsAllowAdditionalScreenshot!: boolean;
    flgIsEmailOnPublish: boolean = false;
}

// Client processing mode for claims/review workflow
// Values are aligned to backend expectations:
// 2 = Machine only, 1 = Human only, 3 = Machine + human
export enum ClientProcessType {
  MachineOnly = 0,
  MachineAndHuman = 1,
  HumanOnly = 2
}

export const ClientProcessOptions = [
  { value: ClientProcessType.MachineOnly, label: 'Machine only' },
  { value: ClientProcessType.HumanOnly, label: 'Human only' },
  { value: ClientProcessType.MachineAndHuman, label: 'Machine + human' }
];

export enum ReportType {
    Basic = 1,
    EnhancedReport = 2,
    Medium = 3
}

export const ReportTypes = [
    { value: 1, label: 'Basic' },
    { value: 2, label: 'Enhanced' },
    { value: 3, label: 'Monitoring' },
    { value: 4, label: 'Identity'}
];

export const PriorityTypes = [
    { value: 1, label: 'Urgent' },
    { value: 2, label: 'High' },
    { value: 3, label: 'Medium' },
    { value: 4, label: 'Low'}
];
export const TurnaroundTimeTypes = [
    { value: 0, label: 'Same day' },
    { value: 1, label: '1 day' },
    { value: 2, label: '2 days' },
    { value: 3, label: '3 days'},
    { value: 4, label: '4 days'},
    { value: 5, label: '5 days'},
    { value: 10, label: '10 days'}
];
export const DeliverableTypes = [
    { value: 1, label: 'PDF' },
    { value: 2, label: 'DOC' },
    { value: 3, label: 'JSON' },
    { value: 4, label: 'EXCEL'}
];
export const SortByWorkbench = [
    { value: 4, label: 'Date' },
    { value: 1, label: 'Priority' },
    { value: 2, label: 'Delivery' },
    { value: 3, label: 'Balanced ' }
 
];
export const InsuranceTypeOptions = [
  { value: 0, label: 'Insurance' },
  { value: 1, label: 'Non-insurance' },
//   { value: 2, label: 'White label' }
];

